import ax from "../axios";

export const createAppointmentKeyStore = (params) => {
  return ax.post("/appointment_key_stores", { params });
};
